/** ============================================================= *
 *  ---------------------- IMPORT - START ----------------------- *
 *  ============================================================= */
import 'what-input'
import jQuery from 'jquery'
import Foundation from 'foundation-sites'
import intlTelInput from 'intl-tel-input'
import 'owl.carousel'
import Swiper from 'swiper'
import {
	Navigation,
	Pagination
} from 'swiper/modules'
import {
	setHrefs
} from './functions/data-hrefs'
import {
	initEqualizeContent
} from './functions/equalizer'
import {
	initTelephoneInput
} from './functions/intl-tel-input'
import {
	initDatepickerInput
} from './functions/datepicker'
import {
	enableNegativeMargins
} from './functions/negative-margins'
import {
	mapStyles
} from './functions/map-styles'
/** ============================================================= *
 *  ----------------------- IMPORT - END ------------------------ *
 *  ============================================================= */



/** ============================================================= *
 *  ------------ GLOBAL VARIABLES DECLARATION - START ----------- *
 *  ============================================================= */
const THEME_FOLDER = "../wp-content/themes/integrityrgv_v1"
const PHONE_FIELD = ".codesm-phone-field"
const DATEPICKER_FIELD = ".codesm-datepicker-field"
const DATEPICKER_FORMAT = "mm/dd/yyyy"
const EQUALIZE_CONTENT = ".codesm-equalize-content"

Foundation.addToJquery(jQuery)
Swiper.use([Navigation, Pagination])
window.intlTelInput = intlTelInput
window.setHrefs = setHrefs
window.initEqualizeContent = initEqualizeContent
window.initTelephoneInput = initTelephoneInput
window.initDatepickerInput = initDatepickerInput
window.enableNegativeMargins = enableNegativeMargins
window.mapStyles = mapStyles
// window.enableCallrailTracking = enableCallrailTracking
/** ============================================================= *
 *  ------------- GLOBAL VARIABLES DECLARATION - END ------------ *
 *  ============================================================= */



jQuery(document).ready(function () {
	jQuery(document).foundation();
	triggerThemeFunctions();

	// ADD YOUR CODE HERE
	// 
	//

	var photoGallerySwiper = new Swiper('.photo-gallery-swiper .swiper-container',{
		direction: 'horizontal',
		slidesPerView: 1,
		slidesPerColumn: 1,
		spaceBetween: 30,
		
		watchSlidesVisibility: true,
		observer: true,
		observeParents: true,
	    pagination: {
			el: ".swiper-pagination",
			clickable: true,

		  },
	   navigation: {
		   nextEl: ".photo-gallery-swiper .swiper-button-next",
		   prevEl: ".photo-gallery-swiper .swiper-button-prev",
		 },
	   breakpoints: {
		   640: {
			   slidesPerView: 1,
			   slidesPerColumn: 1,
			   spaceBetween: 30,
	
		   },
		   1024: {
			   slidesPerView: 1,
			   slidesPerColumn: 1,
			   spaceBetween: 30,
		   },
		   1200: {
			   slidesPerView: 1,
			   slidesPerColumn: 1,
			   spaceBetween: 30,
		   },
			 1440: {
			   slidesPerView: 1,
			   slidesPerColumn: 1,
			   spaceBetween: 30,
		   },
	   }
	});


	var testimonialsSwiper = new Swiper('.testimonials', {
		direction: 'horizontal',
		loop: true,
		spaceBetween: 30,
		autoplay: {
			delay: 2500,
			disableOnInteraction: false
		},
		breakpoints: {
            640: {
                slidesPerView: 1,
                slidesPerColumn: 1,
            },
            1024: {
                slidesPerView: 2,
                slidesPerColumn: 1,
            },
            1200: {
                slidesPerView: 2,
                slidesPerColumn: 1,
            },
            1440: {
                slidesPerView: 2,
                slidesPerColumn: 1,
            },
        }
	});

	var galleryCarouselSwiper = new Swiper('.gallery-carousel .swiper-container', 
	{
		direction: 'horizontal',
        loop: true,
        spaceBetween: 30,
        watchSlidesVisibility: true,
        observer: true,
        observeParents: true,
        pagination: {
            el: ".swiper-pagination",
            clickable: true,

          },
    //    navigation: {
    //        nextEl: ".swiper-button-next",
    //        prevEl: ".swiper-button-prev",
    //      },
        autoplay: {
            delay: 2500,
            disableOnInteraction: false
        },
        breakpoints: {
            640: {
                slidesPerView: 1,
                slidesPerColumn: 1,
            },
            1024: {
                slidesPerView: 2,
                slidesPerColumn: 1,
            },
            1200: {
                slidesPerView: 2,
                slidesPerColumn: 1,
            },
            1440: {
                slidesPerView: 2,
                slidesPerColumn: 1,
            },
        }
	});

	if (document.body.animate) {
		const btns = document.querySelectorAll('.button');
		btns.forEach(btn => {
			btn.addEventListener('mouseover', pop);
		});
	}

	function pop(e) {
		// Quick check if user clicked the button using a keyboard
		if (e.clientX === 0 && e.clientY === 0) {
			const bbox = document.querySelector('.button').getBoundingClientRect();
			const x = bbox.left + bbox.width / 2;
			const y = bbox.top + bbox.height / 2;
			for (let i = 0; i < 30; i++) {
				// We call the function createParticle 30 times
				// We pass the coordinates of the button for x & y values
				createParticle(x, y);
			}
		} else {
			for (let i = 0; i < 30; i++) {
				// We call the function createParticle 30 times
				// As we need the coordinates of the mouse, we pass them as arguments
				createParticle(e.clientX, e.clientY, e);
			}
		}
	}

	function createParticle(x, y, element) {
		console.log(element);
		const particle = document.createElement('particle');
		element.srcElement.append(particle);

		// Calculate a random size from 5px to 25px
		const size = Math.floor(Math.random() * 20 + 5);
		particle.style.width = `${size}px`;
		particle.style.height = `${size}px`;
		// Generate a random color in a blue/purple palette
		particle.style.background = `hsl(80, 58%, 51%)`;

		// Generate a random x & y destination within a distance of 75px from the mouse
		const destinationX = x + (Math.random() - 0.5) * 2 * 75;
		const destinationY = y + (Math.random() - 0.5) * 2 * 75;

		// Store the animation in a variable as we will need it later
		const animation = particle.animate([{
				// Set the origin position of the particle
				// We offset the particle with half its size to center it around the mouse
				transform: `translate(-50%, -50%) translate(${x}px, ${y}px)`,
				opacity: 1
			},
			{
				// We define the final coordinates as the second keyframe
				transform: `translate(${destinationX}px, ${destinationY}px)`,
				opacity: 0
			}
		], {
			// Set a random duration from 500 to 1500ms
			duration: Math.random() * 1000 + 500,
			easing: 'cubic-bezier(0, .9, .57, 1)',
			// Delay every particle with a random value of 200ms
			delay: Math.random() * 200
		});

		// When the animation is complete, remove the element from the DOM
		animation.onfinish = () => {
			particle.remove();
		};
	}

});



/** ======= DO NOT EDIT BELOW THIS POINT UNLESS NECESSARY ======= *
 *  ----------------- THEME FUNCTIONS - START ------------------- *
 *  ======= DO NOT EDIT BELOW THIS POINT UNLESS NECESSARY ======= */
function triggerThemeFunctions() {
	// REMOVE EMPTY P TAGS CREATED BY WP INSIDE OF ACCORDION AND ORBIT
	jQuery('.accordion p:empty, .orbit p:empty').remove();

	// ADD FLEX VIDEO TO YOUTUBE AND VIMEO EMBEDS
	jQuery(':not(.responsive-embed):not(.flex-video)>iframe[src*="youtube.com"], :not(.responsive-embed):not(.flex-video)>iframe[src*="vimeo.com"]').each(function () {
		if (jQuery(this).innerWidth() / jQuery(this).innerHeight() > 1.5) {
			jQuery(this).wrap("<div class='widescreen responsive-embed'/>");
		} else {
			jQuery(this).wrap("<div class='responsive-embed'/>");
		}
	});

	// ENABLE PSEUDO ELEMENTS FOR FONT AWESOME
	window.FontAwesomeConfig = {
		searchPseudoElements: true
	};

	// DISABLE FIRST OPTION
	jQuery('select.disable-first-option').each(function () {
		jQuery(this).find('option').first().attr('disabled', 'disabled');
	});

	// HANDLE DATA-HREF
	window.setHrefs();

	// TRIGGER EQUALIZER
	window.initEqualizeContent(EQUALIZE_CONTENT);

	// INTL-TEL-INPUT
	window.initTelephoneInput(PHONE_FIELD, THEME_FOLDER);

	// ENABLE NEGATIVE MARGINS
	window.enableNegativeMargins();

	// FOUNDATION DATEPICKER
	window.initDatepickerInput(DATEPICKER_FIELD, DATEPICKER_FORMAT);

	// // ENABLE CALLRAIL TRACKING
	// window.enableCallrailTracking();
}
/** ======= DO NOT EDIT ABOVE THIS POINT UNLESS NECESSARY ======= *
 *  ------------------ THEME FUNCTIONS - END -------------------- *
 *  ======= DO NOT EDIT ABOVE THIS POINT UNLESS NECESSARY ======= */